<template>
  <div class="library">
    <navigation/>
    <router-view/>
  </div>
</template>

<script>
import { app } from '@/firebase'
import navigation from '@/components/navigation'

export default {
  name: 'Library',
  components: {
    navigation,
  },
  mounted() {
    const currentUserID = app.auth().currentUser.uid
    this.$store.commit('setActiveUser', currentUserID)
    this.$store.dispatch('setActiverUserSettingsAction', currentUserID)
  }
}
</script>

<style scoped>
  .library {
    margin-top: 90px;
  }
</style>